<div class="bg-white">
  <div class="p-4 border-bottom">
    <h3 class="pt-2">
      {{ 'Sellers.Products.MissingData' | translate }}
    </h3>
  </div>
  <form [formGroup]="businessForm" enctype="multipart/form-data"
        class="p-4" >
    <div class="row align-items-center mb-3">
      <div class="col-4">
        <div class="business-logo-container">
          <img *ngIf="imageSrc" width="150" height="150"
               [src]="sanitizer.bypassSecurityTrustUrl(imageSrc)"
               alt="selectedFile.name" />

          <button type="button" (click)="fileInput.click()" mat-flat-button
                  class="text-white bg-primary change-button">
            <mat-icon *ngIf="!selectedFile">camera_alt</mat-icon>
            <input #fileInput type="file" (change)="onFileInput($event)"
                   accept="image/*" style="display: none;"
                   [formControl]="convertBusinessControls('logo')" />
          </button>

          <mat-error *ngIf="emptyLogo">
            {{ 'Sellers.Products.LogoEmpty' | translate }}

          </mat-error>
        </div>
        <mat-error *ngIf="businessPage.formErrors.logos || !isLogoValid" class="form-error form-error-hidden">
          logo cannot be empty
        </mat-error>
      </div>
      <div class="col-8">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend"  style="width: 35%">
              <span class="input-group-text" style="width: 100%">
                {{ 'Sellers.Products.BusinessName' | translate }} <span class="text-danger">*</span>
              </span>
            </div>
            <input style="width: 65%; display: block" class="form-control" type="text"
                   placeholder="{{ 'Sellers.Products.BusinessName' | translate }}"
                   [formControl]="convertBusinessControls('name')" required />
          </div>
          <small *ngIf="businessPage.formErrors.name" class="form-error form-error-hidden">
            {{ businessPage.formErrors.name }}
          </small>
        </div>
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend" style="width: 35%">
              <span class="input-group-text" style="width: 100%">
                {{ 'Sellers.Products.Category' | translate }} <span class="text-danger">*</span>
              </span>
            </div>
            <div style="width: 65% ; display: block">
              <app-select-box-search *ngIf="categoryOptions" [formControl]="convertBusinessControls('CategoryId')"
                                     [placeholder]="'Sellers.Products.ChooseCategory' | translate"
                                     [list]='categoryOptions' [searchKey]="'name'" ngDefaultControl (valueChange)="changeCategory($event)" >
              </app-select-box-search>
            </div>
          </div>
          <small *ngIf="businessPage.formErrors.CategoryId" class="form-error form-error-hidden">
            {{ businessPage.formErrors.CategoryId }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-md-6 mb-2 d-flex flex-column align-items-start">
        <label *ngIf="!isFacebookVerified">
          {{ 'Sellers.Products.FacebookProfileLink' | translate }} <span class="text-danger">*</span>
        </label>
        <label *ngIf="isFacebookVerified">
          {{ 'Sellers.Products.FacebookVerified' | translate }}
        </label>
        <input class="form-control" type="url"
               [formControl]="convertBusinessControls('link_fb')"
               [readonly]="isFacebookVerified" />
        <small *ngIf="businessPage.formErrors.link_fb" class="form-error form-error-hidden">
          {{ businessPage.formErrors.link_fb }}
        </small>
      </div>
      <div class="col-lg-4 col-md-6 mb-2 d-flex flex-column align-items-start">
        <label *ngIf="!isFacebookVerified">
          {{ 'Sellers.Products.RequestVerification' | translate }} <span class="text-danger">*</span>
        </label>
        <label *ngIf="isFacebookVerified">
          {{ 'Sellers.Products.Verified' | translate }}
        </label>
        <button (click)="facebookVerificationPopup()" class="btn btn-primary mx-0" [disabled]="isFacebookVerified">
          {{ 'Sellers.Products.VerifyFacebook' | translate }}
        </button>
        <small *ngIf="facebookErrorMsg" class="form-error form-error-hidden">
          {{ 'Sellers.Products.VerifyFacebook' | translate }}
        </small>
      </div>
    </div>
  </form>
  <form [formGroup]="bankForm" enctype="multipart/form-data" class="p-4" *ngIf="bankFields">
    <div class="row">
      <div class="alert alert-success" role="alert">
        <ol class="fw-bold mb-0" style="line-height: 25px;font-family: sans-serif;font-size: 13px;">
          <li>
            {{ 'Sellers.Products.BankWarning01' | translate }}
          </li>
          <li>
            {{ 'Sellers.Products.BankWarning02' | translate }}
          </li>
          <li>
            {{ 'Sellers.Products.BankWarning03' | translate }}
          </li>
        </ol>
      </div>
      <div class="col-12 col-sm-6 d-flex flex-column align-items-start my-4">
        <label>{{ 'Sellers.Products.BankName' | translate }} <span class="text-danger">*</span></label>
        <select [formControl]="convertBankControls('bank_id')"
                class="form-control" required
                (change)="onBankSelection($event)">
          <option *ngFor="let bank of banks" [value]="bank.id">
            {{ bank.bank_name }}
          </option>
        </select>
        <small *ngIf="bankPage.formErrors.bank_id"
               class="form-error form-error-hidden">
          {{ bankPage.formErrors.bank_id }}
        </small>
      </div>

      <div class="col-12 col-sm-6 d-flex flex-column align-items-start my-4">
        <label>{{ 'Sellers.Products.BranchName' | translate }} <span class="text-danger">*</span></label>
        <select [formControl]="convertBankControls('BranchId')"
          class="form-control" required>
          <option *ngFor="let bankBranch of bankBranches"
                  [value]="bankBranch.id">
            {{ bankBranch.english_branch_name }}
          </option>
        </select>
        <small *ngIf="bankPage.formErrors.BranchId"
          class="form-error form-error-hidden">
          {{ bankPage.formErrors.BranchId }}
        </small>
      </div>

      <div class="col-12 col-sm-6 d-flex flex-column align-items-start my-4">
        <label>{{ 'Sellers.Products.AccountHolderName' | translate }} <span class="text-danger">*</span></label>
        <input class="form-control" type="text" required
          [formControl]="convertBankControls('holder_name')"/>
        <small *ngIf="bankPage.formErrors.holder_name"
          class="form-error form-error-hidden">
          {{ bankPage.formErrors.holder_name }}
        </small>
      </div>

      <div class="col-12 col-sm-6 d-flex flex-column align-items-start my-4">
        <label>
          {{ 'Sellers.Products.AccountNumber' | translate }} <span class="text-danger">*</span>
        </label>
        <input class="form-control" type="text" required
               [formControl]="convertBankControls('account_number')"/>
        <small
          *ngIf="bankPage.formErrors.account_number"
          class="form-error form-error-hidden">
          {{ bankPage.formErrors.account_number }}
        </small>
      </div>
    </div>
  </form>
  <div class="row me-3">
    <div class="col m-auto d-flex justify-content-end">
      <button type="submit" (click)="onSubmit()" class="btn btn-primary mb-5">
        {{ 'Sellers.Products.Submit' | translate }}
      </button>
    </div>
  </div>
</div>
